import { render, staticRenderFns } from "./PdfmdpsepIndextab5.vue?vue&type=template&id=905f9954"
import script from "./PdfmdpsepIndextab5.vue?vue&type=script&lang=js"
export * from "./PdfmdpsepIndextab5.vue?vue&type=script&lang=js"
import style0 from "./PdfmdpsepIndextab5.vue?vue&type=style&index=0&id=905f9954&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports